// Gratisversand-Upsell auf der Warenkorbseite.
// Listener am document, damit sie die Neu-Renderung von .js-contents durch cart.js ueberstehen.
(function () {
  if (window.cartFreeShippingInit) return;
  window.cartFreeShippingInit = true;

  function resolveVariant(item) {
    const selects = item.querySelectorAll('[data-cart-fs-option]');
    const chosen = Array.from(selects).map((select) => select.value);
    if (chosen.some((value) => !value)) return null;

    const json = item.querySelector('[data-cart-fs-variants]');
    if (!json) return null;
    let variants = [];
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
    return variants.find((v) => v.options.every((value, i) => value === chosen[i])) || null;
  }

  // Die Auswahlfelder liegen innerhalb von <cart-items>. Deren change-Listener wuerde sonst
  // eine Mengenaenderung ohne Zeile ausloesen. Darum in der Capture-Phase abfangen und hier behandeln.
  document.addEventListener(
    'change',
    function (event) {
      const select = event.target.closest('[data-cart-fs-option]');
      if (!select) return;
      event.stopPropagation();

      const item = select.closest('[data-cart-fs-item]');
      const button = item.querySelector('[data-cart-upsell-add]');
      const variant = resolveVariant(item);

      if (variant && variant.available) {
        button.dataset.variantId = variant.id;
        button.disabled = false;
      } else {
        delete button.dataset.variantId;
        button.disabled = true;
      }
    },
    true
  );

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;
    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    button.setAttribute('aria-busy', 'true');

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: 'warenkorb' } }],
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.reload();
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        const errors = document.getElementById('cart-errors');
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
      });
  });
})();